import { JsonDecoder } from 'ts.data.json';
import { OrderReinstateResponse } from './model';

export const orderReinstateResponseDecoder = JsonDecoder.object<OrderReinstateResponse>(
    {
        id: JsonDecoder.string,
        status: JsonDecoder.string
    },
    'OrderReinstateResponse'
);
